<template>
  <div
    class="block-item"
    @click="bindClickBlock"
    :class="{ 'block-item-active': active }"
  >
    <div class="">{{ data.name }}</div>
    <div class="number" v-if="data.currPeriodVal !== undefined"
      ><span>{{ data.currPeriodVal | filterNumber }}</span></div
    >
    <div class="" v-if="data.lastPeriodVal !== undefined">
      <div>{{ typeData[type] }}{{ textData.lastPeriodVal }}</div>
      <div class="number">{{ data.lastPeriodVal | filterNumber }}</div>
    </div>
    <div class="" v-if="data.periodIncrRate !== undefined"
      ><span class="text">{{ textData.periodIncrRate + data.rateType }}:</span
      ><span :class="[getUpDown(data.periodIncrRate)]">{{
        data.periodIncrRate | filterNumber
      }}</span></div
    >
    <div class="number" v-if="data.yesterdayVal !== undefined">{{
      data.yesterdayVal | filterNumber
    }}</div>
    <div class="" v-if="data.dayIncrRate !== undefined"
      ><span class="text">{{ textData.dayIncrRate + data.rateType }}:</span
      ><span :class="[getUpDown(data.dayIncrRate)]">{{
        data.dayIncrRate | filterNumber
      }}</span>
    </div>
    <div class="" v-if="data.weekIncrRate !== undefined"
      ><span class="text">{{ textData.weekIncrRate + data.rateType }}:</span
      ><span :class="[getUpDown(data.weekIncrRate)]">{{
        data.weekIncrRate | filterNumber
      }}</span>
    </div>
    <div class="" v-if="data.monthIncrRate !== undefined"
      ><span class="text">{{ textData.monthIncrRate + data.rateType }}:</span
      ><span :class="[getUpDown(data.monthIncrRate)]">{{
        data.monthIncrRate | filterNumber
      }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    active: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  filters: {
    filterNumber(val) {
      if (val === undefined || val === null) {
        return '-'
      } else {
        return val
      }
    }
  },
  data() {
    return {
      typeData: {
        day: '昨日',
        week: '上周',
        month: '上月'
      },
      textData: {
        currPeriodVal: '本期指标值',
        lastPeriodVal: '同期数据',
        periodIncrRate: '同期',
        yesterdayVal: '昨日指标值',
        dayIncrRate: '日',
        weekIncrRate: '周',
        monthIncrRate: '月'
      }
    }
  },
  methods: {
    getUpDown(str) {
      return parseFloat(str || 0) >= 0 ? 'up' : 'down'
    },
    bindClickBlock() {
      this.$emit('click', this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
.block-item {
  white-space: nowrap;
  border: 1px solid #caccd1;
  border-radius: 4px;
  padding: 10px;
  width: 120px;
  box-sizing: border-box;
  font-family: PingFangSC;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
  margin-right: 10px;
  margin-bottom: 10px;

  .number {
    font-size: 18px;
    font-weight: 600;
  }

  .text {
    margin-right: 4px;
  }
  .up {
    color: #ff0000;
  }
  .down {
    color: #34bf49;
  }
}
.block-item-active {
  background-color: #9ecffc;
  border: 1px solid #9ecffc;
  color: #fff;
}
</style>
